import { Navigate } from "react-router";
import { useGetTreeMarkingQuery } from "../../../apis/TreeMarking.api";
import { PrimaryTreeMarking, TreeMarking } from "../../../types/models/TreeMarking";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const TreeMarkingScoped = () => {
    const {
        data,
    } = useGetTreeMarkingQuery(PrimaryTreeMarking.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/tree-markings/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default TreeMarkingScoped;
